import { useAuthService } from '@/utils/auth'
import { isChunkLoadError } from '@/utils/chunkReload'

const loadLayout = async (layout: string) => {
  try {
    return (await import(`@/layouts/${layout}.vue`)).default
  } catch (e) {
    if (isChunkLoadError(e)) throw e
    return (await import(`@/layouts/Default.vue`)).default
  }
}

export const layoutMiddleware = async (route: any) => {
  const authService = useAuthService()
  const rahmatToken = authService.getRahmatToken()
  const isRahmatFlow = !!rahmatToken

  const flowDependentRoutes = ['main', 'menu']
  const routeName = route.name?.toString() || ''

  const layout = flowDependentRoutes.includes(routeName)
    ? isRahmatFlow
      ? 'RahmatLayout'
      : 'Default'
    : route.meta.layout || 'Default'

  route.meta.layoutComponent = await loadLayout(layout)
}
